module.exports = {"530826101":"勐烈镇","530826102":"整董镇","530826103":"曲水镇","530826104":"宝藏镇","530826105":"康平镇","530826202":"国庆乡","530826203":"嘉禾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530826.json
// module id = 2411
// module chunks = 0